import React from 'react';
import cx from 'clsx';
import * as css from './Aside.module.scss';

export interface AsideProps {
    children?: React.ReactNode;
    className?: string;
    hideRule?: boolean;
}

export function Aside(props: AsideProps) {
    const { children, className, hideRule, ...rest } = props;
    const captionClasses = cx(css.aside, !!hideRule && css.asideNoRule, className);
    return <aside className={captionClasses} {...rest} children={children} />;
}
